import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css'],
  providers: [DatePipe]
})
export class UserComponent implements OnInit {
  currentUser;
  currentDateTime: Date = new Date();

  constructor(private auth: AuthService) {
    this.auth.currentUser.subscribe(data => {
      this.currentUser = data;
    });
  }

  ngOnInit() {
    this.auth.getUser();
    setInterval(() => {
      this.currentDateTime = new Date();
    }, 30000);
  }

  logout() {
    this.auth.logout();
  }
}
